import localGetter from '../getters/localGetter'
import localAction from '../actions/localAction'
import localMutation from '../mutations/localMutation'

const localModule = {
    state: {
        enrollstudent: [],
        enroll: {}
    },
    getters: localGetter,
    actions: localAction,
    mutations: localMutation
}

export default localModule;



// WEBPACK FOOTER //
// ./src/store/jzjy/modules/localModule.js